export enum DraftStatus {
  InProgress = 'InProgress',
  Completed = 'Completed',
}

export interface IDraft {
  avatarId: string;
  createdAt: string;
  draftStatus: DraftStatus;
  id: string;
  name: string;
  processedVideo: string | null;
  speechContentId: string;
  thumbnail: string | null;
  updatedAt: string;
  userAudioTrackId: string;
  userId: string;
  avatar: {
    thumbnail: string;
  };
  speechContent: {
    content: string;
  };
}

export enum ScrapStatus {
  NotStarted = 'NotStarted',
  InProgress = 'InProgress',
  Success = 'Success',
  Error = 'Error',
}

export interface ScrapedData {
  userId: string;
  url: string;
  scrapedContent?: string;
  status: ScrapStatus;
}

export interface ContentDraft {
  id?: string;
  content?: string;
}
